import ApiService from '@/service/ApiService';
import { defineStore } from 'pinia';

export const useCommonCodeStore = defineStore('commonCode', {
    state: () => ({
        commonCodes: [],
        error: null
    }),
    actions: {
        async fetchCommonCodes() {
            this.error = null;
            const url = '/api/autoComplete';

            try {
                const response = await ApiService.get(url);
                this.setCommonCodes(response.data && response.data.data ? response.data.data : []);
                //console.log(response.data.data);
            } catch (err) {
                console.error('Error Get Commoncodes:', err.message);
                this.error = err.message;
                this.setCommonCodes([]);
                //throw err;
            }
        },
        setCommonCodes(data) {
            this.commonCodes = data;
        }
    },
    getters: {
        getCommonCodes: (state) => state.commonCodes
    }
});
